import { debug } from '../../../../../../shared/lib/general';
import { VolumeOption } from '../VolumeOption/VolumeOption';

import styles from './VolumeOptionsList.module.css';

interface VolumeOptionsListProps {
    availableVolumes: readonly number[];
    currentVolume: number | '';
    volumeSymbol: string;
    onSelect: (volume: number) => void;
    /** Volume marked as redeemable with loyalty points (the cheapest option). */
    loyaltyVolume?: number | null;
}

export const VolumeOptionsList = ({
    availableVolumes,
    currentVolume,
    volumeSymbol,
    onSelect,
    loyaltyVolume,
}: VolumeOptionsListProps) => {
    return (
        <div className={styles.volumes}>
            {availableVolumes.map((volume) => (
                <VolumeOption
                    key={volume}
                    onClick={() => {
                        onSelect(volume);
                        debug(`volume ${volume}`, 'data');
                    }}
                    isSelected={currentVolume === volume}
                    isLoyaltyOption={
                        loyaltyVolume != null && volume === loyaltyVolume
                    }
                >
                    <span>
                        {volume} {volumeSymbol}
                    </span>
                </VolumeOption>
            ))}
        </div>
    );
};
